import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "quotemark",
  "use": "quotemark-usage",
  "viewBox": "0 0 30 23",
  "content": "<symbol viewBox=\"0 0 30 23\" xmlns=\"http://www.w3.org/2000/svg\" id=\"quotemark\">\r\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M30 11.536L30 0.0720901L17.6469 0.0720911L17.6469 11.536L24.7058 11.536C24.7058 15.1537 21.5452 18.0869 17.6469 18.0869L17.6469 23C24.47 23 30 17.8677 30 11.536ZM-4.74394e-07 18.0869L0 23C6.82269 23 12.3531 17.8677 12.3531 11.536L12.3531 0.0720915L-2.21384e-06 0.0720925L-1.10692e-06 11.536L7.0589 11.536C7.0589 15.1537 3.89824 18.0869 -4.74394e-07 18.0869Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol